import { render, staticRenderFns } from "./YearInReview.vue?vue&type=template&id=c95d5962"
import script from "./YearInReview.vue?vue&type=script&lang=js"
export * from "./YearInReview.vue?vue&type=script&lang=js"
import style0 from "./YearInReview.vue?vue&type=style&index=0&id=c95d5962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports